import { render } from "./FooterComp.vue?vue&type=template&id=82901aa6&scoped=true"
const script = {}

import "./FooterComp.vue?vue&type=style&index=0&id=82901aa6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-82901aa6"

export default script